module.exports = __webpack_public_path__ + "img/users.c74964a6.svg";